import { Navigate, Outlet } from "react-router-dom";
import { RootState } from "../store/store";
import { useSelector } from "react-redux";

const useAuth = () => {
  const { data } = useSelector((state: RootState) => state.auth);
  const user = localStorage.getItem("data");
  return user || data;
};

const ProtectedRoutes = () => {
  const isAuth = useAuth();
  return isAuth ? <Outlet /> : <Navigate to="/login" />;
};
export default ProtectedRoutes;
